module.exports = __webpack_public_path__ + "img/38.dc806496.jpg";